export default {
    internalServerErrorMessage: 'Something went wrong on our end. If the issue persists please contact support.',
    duplicateEntryErrorMessage: 'Duplicate entry: the item already exists, but has been archived.',
    accessForbiddenErrorMessage: 'Access forbidden',
    accessUnauthorizedErrorMessage: 'Unauthorized',
    genericErrorMessage: 'An error has occurred. If the issue persists please contact support.',
    clickResetMessage: 'Click the reset button to try again.',
}
